import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ColoredStatisticsGroup } from '@pages/statistics-page/interfaces';
import { ChipComponent } from '@shared/components/chip/chip.component';

@Component({
  selector: 'app-pinned-groups-area',
  imports: [TranslateModule, ChipComponent],
  templateUrl: './pinned-groups-area.component.html',
  styleUrls: ['./pinned-groups-area.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PinnedGroupsAreaComponent {
  private translate = inject(TranslateService);

  @Input() selectedGroups: ColoredStatisticsGroup[] | null;
  @Output() removeSelection = new EventEmitter<number>();

  removeScoreSelection(id: number): void {
    this.removeSelection.emit(id);
  }

  hasSelectedGroups(): boolean {
    return !!this.selectedGroups?.filter(g => !g.hidden).length;
  }

  getChipLabel(group: ColoredStatisticsGroup): string {
    return group.labelTranslationKey
      ? this.translate.instant(group.labelTranslationKey)
      : group.description;
  }
}
